<template>
  <button
    @click.prevent.stop="submitFavorite()"
    content="Favoritos"
    v-tippy="{ arrow: true, theme: 'green' }"
    class="focus:outline-none"
  >
    <div>
      <svg
        :class="active ? 'text-ontick-red-500' : 'text-ontick-red-700'"
        class="h-7 w-7 transition-all duration-500 ease-in-out"
        :fill="active ? '#F56565' : 'transparent'"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        ></path>
      </svg>
    </div>
  </button>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    id_favorite: {
      type: Number,
      default: "",
    },

    active: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      data_favorite: [],
      status: "",
    };
  },

  computed: {
    ...mapState({
      favorite: (state) => state.marketplace.favorite,
      accountTypes: (state) => state.accountTypes,
    }),
  },

  methods: {
    ...mapActions({
      postFavorite: "marketplace/postFavorite",
      getMarketplaceFavorite: "marketplace/getMarketplaceFavorite",
      favoriteClear: "marketplace/favoriteClear",
    }),

    submitFavorite() {
      let params = {
        id_favorite: this.id_favorite,
        favorite: this.favorite,
      };
      this.postFavorite(params).then(() => {
        this.getMarketplaceFavorite().then((response) => {
          if (response.msg == "Nenhuma preferência encontrada") {
            this.favoriteClear();
          }
        });

        let eventValue = `(${this.accountTypes.selectedAccount.broker_name} - ${this.accountTypes.selectedAccount.account_number}) ${params.id_favorite}`;
        if (this.favorite.includes(params.id_favorite)) {
          this.$gtm.trackEvent({
            event: "interaction", // Event type [default = 'interaction'] (Optional)
            category: "Favoritos",
            action: "click",
            label: "Produto adicionado aos favoritos",
            value: eventValue,
          });
        } else {
          this.$gtm.trackEvent({
            event: "interaction", // Event type [default = 'interaction'] (Optional)
            category: "Favoritos",
            action: "click",
            label: "Produto removido dos favoritos",
            value: eventValue,
          });
        }
      });
    },
  },
};
</script>
<style></style>
